import { connect } from 'react-redux';
import { fetchWrapupsIfNeeded } from 'project/ducks/wrapup';
import SignContract from 'project/components/wrapup/sign_contract';

export default connect(undefined, {
  fetchWrapupsIfNeeded,
})(SignContract);



// WEBPACK FOOTER //
// ./project/containers/wrapup/sign_contract.js